/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_After_Pain_DiscomfortInputs */

const en_us2_workout_after_pain_discomfort = /** @type {(inputs: Workout_After_Pain_DiscomfortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discomfort`)
};

const pt_br2_workout_after_pain_discomfort = /** @type {(inputs: Workout_After_Pain_DiscomfortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desconforto`)
};

const es_419_workout_after_pain_discomfort = /** @type {(inputs: Workout_After_Pain_DiscomfortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Molestia`)
};

const pt_pt2_workout_after_pain_discomfort = /** @type {(inputs: Workout_After_Pain_DiscomfortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desconforto`)
};

const fr_fr2_workout_after_pain_discomfort = /** @type {(inputs: Workout_After_Pain_DiscomfortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gêne`)
};

const de_de2_workout_after_pain_discomfort = /** @type {(inputs: Workout_After_Pain_DiscomfortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unbehagen`)
};

const it_it2_workout_after_pain_discomfort = /** @type {(inputs: Workout_After_Pain_DiscomfortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fastidio`)
};

/**
* | output |
* | --- |
* | "Discomfort" |
*
* @param {Workout_After_Pain_DiscomfortInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_pain_discomfort = /** @type {((inputs?: Workout_After_Pain_DiscomfortInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_Pain_DiscomfortInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_pain_discomfort(inputs)
	if (locale === "es-419") return es_419_workout_after_pain_discomfort(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_pain_discomfort(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_pain_discomfort(inputs)
	if (locale === "de-DE") return de_de2_workout_after_pain_discomfort(inputs)
	if (locale === "it-IT") return it_it2_workout_after_pain_discomfort(inputs)
	return en_us2_workout_after_pain_discomfort(inputs)
});
export { workout_after_pain_discomfort as "workout-after.pain_discomfort" }